const css = `.surveys-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1280px;
}
.surveys-page .surveys-tabs .p-tabview-nav {
  background: transparent;
}
.surveys-page .surveys-tabs .p-tabview-nav-link {
  gap: 8px;
  background: transparent;
}
.surveys-page .surveys-tabs .p-tabview-panels {
  padding: 24px 0 0;
  background: transparent;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL3BhZ2VzL1N1cnZleXMiLCJzb3VyY2VzIjpbIlN1cnZleXMuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUdFO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5zdXJ2ZXlzLXBhZ2Uge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBnYXA6IDI0cHg7XG4gIG1heC13aWR0aDogMTI4MHB4O1xuXG4gIC5zdXJ2ZXlzLXRhYnMge1xuICAgIC5wLXRhYnZpZXctbmF2IHtcbiAgICAgIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50O1xuICAgIH1cblxuICAgIC5wLXRhYnZpZXctbmF2LWxpbmsge1xuICAgICAgZ2FwOiA4cHg7XG4gICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcbiAgICB9XG5cbiAgICAucC10YWJ2aWV3LXBhbmVscyB7XG4gICAgICBwYWRkaW5nOiAyNHB4IDAgMDtcbiAgICAgIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50O1xuICAgIH1cbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
